module.exports = __webpack_public_path__ + "static/media/TWT-BNB.a887264a.svg";